import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { withRouter } from 'react-router';
import { logout } from '../../Redux/Actions/authActions';
import { fetchDispatch } from '../../Containers/Dispatch/actions';
import SnackBar, { formatDate } from '../../Containers/Snackbar';
import moment from 'moment';
import DatePicker from 'material-ui/DatePicker';
import areIntlLocalesSupported from 'intl-locales-supported';
let DateTimeFormat;

/**
 * Use the native Intl.DateTimeFormat if available, or a polyfill if not.
 */
if (areIntlLocalesSupported(['fr', 'fa-IR'])) {
  DateTimeFormat = global.Intl.DateTimeFormat;
} else {
  const IntlPolyfill = require('intl');
  DateTimeFormat = IntlPolyfill.DateTimeFormat;
  require('intl/locale-data/jsonp/fr');
  require('intl/locale-data/jsonp/fa-IR');
}

class Menu extends Component {
  updateHeaderMenu = formatedDate => {
    const { location } = this.props;
    let style = '';
    if (location.pathname === '/') {
      if (formatedDate === formatDate(new Date())) {
        style = 'green-menu';
      } else if (formatedDate.split('-')[0] === '1970') {
        style = 'grey-menu';
      } else {
        style = 'red-menu';
      }
    }

    return style;
  };

  logout = () => {
    const { onLogout } = this.props;
    onLogout();
  };

  handleDateChange = (e, date) => {
    const { onFetchDispatch } = this.props;
    onFetchDispatch(moment(date).format('YYYY-MM-DD'));
  };

  unformatDate = formattedDate => {
    if (formattedDate) {
      const dateParts = formattedDate.split('-');
      return new Date(dateParts[0], dateParts[1] - 1, dateParts[2]);
    }
  };

  render() {
    const { date, location, auth } = this.props;
    const isAdmin = auth.user && auth.user.userType === 'admin';
    const colorMenu =
      isAdmin && date
        ? this.updateHeaderMenu(moment(date).format('YYYY-MM-DD'))
        : '';
    let headerclass = `${colorMenu} bg-color`;
    if (!isAdmin) {
      headerclass += ' consultDispatch';
    }

    if (location.pathname === '/login') {
      return <div />;
    }

    return (
      <header className={headerclass} id="header">
        {location.pathname === '/' && isAdmin && <SnackBar />}
        <nav className="navbar navbar-default">
          {!isAdmin && (
            <div className="datepicker-container">
              <DatePicker
                hintText="Date"
                autoOk
                formatDate={this.formatDate}
                locale="fr"
                DateTimeFormat={DateTimeFormat}
                okLabel="OK"
                cancelLabel="Annuler"
                onChange={this.handleDateChange}
                value={this.unformatDate(date)}
                firstDayOfWeek={0}
              />
            </div>
          )}
          <div className="container-fluid">
            <ul className="nav navbar-nav">
              {isAdmin && (
                <React.Fragment>
                  <li className="nav-item">
                    <Link className="nav-link" to="/">
                      Cédule
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link" to="/clients">
                      Clients / Travaux
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link" to="/employees">
                      Employés
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link" to="/trucks">
                      Véhicules
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link" to="/toolboxes">
                      Coffres / Remorques
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link" to="/users">
                      Usagés
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link" to="/configurations">
                      Configuration
                    </Link>
                  </li>
                </React.Fragment>
              )}
              <li className="nav-item">
                <Link className="nav-link" to="/login" onClick={this.logout}>
                  Déconnexion
                </Link>
              </li>
            </ul>
          </div>
        </nav>
        <div className="mobile-disconnect">
          <Link className="nav-link" to="/login" onClick={this.logout}>
            Déconnexion
          </Link>
        </div>
      </header>
    );
  }
}

Menu.defaultProps = {
  auth: {},
};

const mapStateToProps = state => ({
  date: state.dispatch.date,
  auth: state.auth,
});

const mapDispatchToProps = dispatch => ({
  onFetchDispatch: date => dispatch(fetchDispatch(date)),
  onLogout: () => dispatch(logout()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(Menu));
